module.exports = __webpack_public_path__ + "static/media/A7.b3c2a893.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/A7.png
// module id = 873
// module chunks = 0